import styled from "styled-components";

export const UnderConstructionWrapper = styled.div`
  width: 100%;
  height: inherit;
  background: linear-gradient(90deg, transparent 50%, #3fca89 50%);
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;

  & > p {
    padding: 5rem;
    font-family: "Righteous", sans-serif;
    letter-spacing: -6px;
    font-weight: bolder;
    font-size: 14rem;
    background: linear-gradient(90deg, #3fca89 50%, #181818 50%);
    background-clip: text;
    text-align: center;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  @media only screen and (max-width: 1110px) {
    & > p {
      font-size: 8rem;
    }
  }

  @media only screen and (max-width: 619px) {
    & > p {
      font-size: 5rem;
    }
  }

  @media only screen and (max-width: 393px) {
    & {
      background: linear-gradient(90deg, transparent 50%, transparent 50%);
    }

    & > p {
      font-size: 5rem;
      transform: rotate(90deg);
      background: linear-gradient(90deg, #3fca89 50%, #3fca89 50%);
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      letter-spacing: 3px;
    }
  }
`;
